import React from 'react'
import ListPackagedPage from './ListPackagedPage'
import '../styles/index.scss'

function ListPackagedPageContainer() {
  return (
    <div className="ListPackagedPageContainer py-5">
        <ListPackagedPage/>
    </div>
  )
}

export default ListPackagedPageContainer